import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { CartProvider } from "@/context/CartContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import ErrorBoundary from "@/components/ErrorBoundary";
import ChatbotWidget from "@/components/ChatbotWidget";
import { Home } from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import Websites from "@/pages/Websites";
import Training from "@/pages/Training";
import { Services } from "@/pages/Services";
import { About } from "@/pages/About";
import { Locations } from "@/pages/Locations";
import { Contact } from "@/pages/Contact";
import { NotFound } from "@/pages/NotFound";
import CheckoutStatus from "@/pages/CheckoutStatus";
import PesapalStatus from "@/pages/PesapalStatus";
import Admin from "@/pages/Admin";
import ServiceLanding from "@/pages/ServiceLanding";
import CoursePage from "@/pages/CoursePage";
import TrackOrder from "@/pages/TrackOrder";
import Build from "@/pages/Build";
import { LANDINGS } from "@/data/landings";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [pathname]);
  return null;
}

function Layout() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) {
    return (
      <Routes>
        <Route path="/admin" element={<Admin />} />
      </Routes>
    );
  }
  return (
    <>
      <ScrollTop />
      <ErrorBoundary silent name="navbar" resetKey={location.pathname}><Navbar /></ErrorBoundary>
      <main className="flex-1">
        <ErrorBoundary name="page" resetKey={location.pathname}>
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:productId" element={<ProductDetail />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/websites" element={<Websites />} />
          <Route path="/training" element={<Training />} />
          <Route path="/training/:slug" element={<CoursePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/build" element={<Build />} />
          <Route path="/checkout/status" element={<CheckoutStatus />} />
          <Route path="/track" element={<TrackOrder />} />
          <Route path="/pesapal/status" element={<PesapalStatus />} />
          {LANDINGS.map((l) => (
            <Route key={l.slug} path={`/${l.slug}`} element={<ServiceLanding slug={l.slug} />} />
          ))}
          <Route path="*" element={<NotFound />} />
          </Routes>
        </ErrorBoundary>
      </main>
      <ErrorBoundary silent name="footer" resetKey={location.pathname}><Footer /></ErrorBoundary>
      <ErrorBoundary silent name="chatbot"><ChatbotWidget /></ErrorBoundary>
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col overflow-x-hidden bg-[#0A0F0B]">
      <HelmetProvider>
        <CartProvider>
          <CurrencyProvider>
            <BrowserRouter>
              <ErrorBoundary name="root"><Layout /></ErrorBoundary>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
          </CurrencyProvider>
        </CartProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
